import React from 'react';
import {BrowserRouter as Router, Switch, Route, Redirect} from 'react-router-dom';
import {Login, About} from './pages';
import {ChatbotVaribles} from './pages/ChatbotVaribles';
import MainLayout from './pages/layouts/MainLayout';
import {renderIfAuthenticated} from './utils';

const LoginRoute = () => {
  if (localStorage.getItem('sid')) {
    return <Redirect to="/" />;
  }
  return <Login />;
};

const Routes = () => {
  return (
    <Router>
      <Switch>
        {/* <Route exact path="/about">
          <About />
        </Route> */}
        <Route exact path="/login">
          <LoginRoute />
        </Route>
        <Route
          path="/chatbot-variables/:chatbotId"
          exact
          render={(props) =>
            renderIfAuthenticated({
              component: <ChatbotVaribles />,
              ...props,
            })
          }
        />
        <Route
          render={(props) =>
            renderIfAuthenticated({
              component: <MainLayout {...props} />,
              ...props,
            })
          }
        />
      </Switch>
    </Router>
  );
};

export default Routes;
